module.exports = __webpack_public_path__ + "img/talentQuote2@2x.67bf5cf0.jpg";